import { create } from 'zustand';
import { Dayjs } from 'dayjs';
import { getShiftToPublish } from '@libs/api/shifts';
import { TIMEZONE_FALLBACK } from '@libs/config';
import { ShiftList } from '@libs/models/shifts/shift';

const FallbackTimezone = TIMEZONE_FALLBACK;

type DateFilterValue = { from?: Dayjs; to?: Dayjs; timezone: string };

type State = {
  loading: boolean;
  drawerOpen: boolean;
  rotationId: string;
  drawerMode: 'add' | 'edit';
  initiated: boolean;
  shiftsToPublish: ShiftList[];
  loadPublishableShifts: (options: {
    dateFilter: DateFilterValue | null;
    locationId: string;
    qualifications?: string[];
  }) => void;
  openShiftPublishDrawer: (id?: string) => void;
  closeShiftPublishDrawer: () => void;
};

export const usePublishDrawerStore = create<State>()((set) => ({
  loading: false,
  drawerOpen: false,
  drawerMode: 'add',
  initiated: false,
  rotationId: '',
  shiftsToPublish: [],
  loadPublishableShifts: async (options) => {
    const { dateFilter, locationId, qualifications = [] } = options;
    set({ loading: true });

    try {
      const timezone = dateFilter?.timezone || FallbackTimezone;

      const shifts = await getShiftToPublish({
        timezone,
        startDate: dateFilter?.from,
        endDate: dateFilter?.to,
        filters: {
          locations: { key: 'locations', value: [locationId] },
          qualifications: { key: 'qualifications', value: qualifications },
        },
      });
      set({
        loading: false,
        shiftsToPublish: shifts,
      });
    } finally {
      set({ loading: false, initiated: true });
    }
  },
  openShiftPublishDrawer: (id) => {
    set({ drawerMode: id ? 'edit' : 'add', rotationId: id, drawerOpen: true });
  },
  closeShiftPublishDrawer: () => {
    set({ drawerOpen: false });
  },
}));
